import _ from 'lodash';

import { buildApplicationState } from './applicationManager';

export function userIsIndicativeOfferFlow(ui) {
    return ui.attributes && ui.attributes.indicative_offer_enabled === true;
}

export function getGuarantors(application, formValues) {
    const state = buildApplicationState(application, formValues);
    if (!state.people) {
        return [];
    }
    return state.people.filter(
        (person) =>
            _.includes(person.roles, 'guarantor') &&
            !_.includes(person.roles, 'applicant')
    );
}

export function getApplicantState(application, formValues) {
    const state = buildApplicationState(application, formValues);
    return state.people.map((value, index) => {
        if (value.roles.indexOf('applicant') > -1) {
            return {
                index,
                roles: _.uniq(value.roles.concat('guarantor'))
            };
        }
        return undefined;
    });
}
